export const StandaloneMultiSelectTestAttributes = {
    selectAllButtonE2eClass: 'standalone-multiselect-select-all',
    clearAllButtonE2eClass: 'standalone-multiselect-clear-all',
};
